import { Switch as HeadlessSwitch } from "@headlessui/react";
import { twMerge } from "tailwind-merge";

export const Switch = (props: {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}) => {
  return (
    <HeadlessSwitch
      disabled={props.disabled}
      checked={props.checked}
      onChange={props.onChange}
      onClick={props.onClick}
      className={twMerge(
        props.checked
          ? "bg-green-500 hover:bg-green-600 focus:ring-green-500 dark:bg-emerald-500 dark:hover:bg-emerald-400 dark:focus:ring-emerald-500"
          : "bg-neutral-200 hover:bg-neutral-300 focus:ring-neutral-300 dark:bg-zinc-700 dark:hover:bg-zinc-600 dark:focus:ring-zinc-600",
        "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 disabled:ring-zinc-200 dark:focus:ring-offset-zinc-900 dark:disabled:ring-zinc-800",
        props.className,
      )}
    >
      <span
        aria-hidden={"true"}
        className={twMerge(
          props.checked ? "translate-x-5" : "translate-x-0",
          "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out dark:bg-zinc-100",
        )}
      />
    </HeadlessSwitch>
  );
};
